/** Vietnamese display order: Họ (lastName) + Tên (firstName). */
export type PersonNameParts = {
  firstName?: string | null;
  lastName?: string | null;
};

export function formatPersonName(
  person: PersonNameParts | null | undefined,
  fallback = ''
): string {
  if (!person) return fallback;
  const name = `${person.lastName || ''} ${person.firstName || ''}`.trim();
  return name || fallback;
}
